import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';

import { AppRoute } from 'app/app-layout/constants/app-route.enum';
import { AuthService } from 'app/core/authentication/services/auth.service';
import { RouterRequest } from 'app/core/browser/models/router-request.model';
import { BrowserService } from 'app/core/browser/services/browser.service';

@Component({
  selector: 'cz-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  constructor(private readonly _browserService: BrowserService,
              private readonly _authService: AuthService,
              private _dialogRef: MatDialog) { }

  public ngOnInit(): void {
    this._dialogRef.closeAll();
    sessionStorage.clear();
    this._authService.signOut(true, 'api/logout?userLogout=').subscribe((res: any) => {
    },                                                                  (error: any) => {

    });
      // Go to login page after logging out.
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.login });
    this._browserService.to(navRequest);
    const adminWindow = this._authService.getAdminSiteWindow();
    if(adminWindow) {
      this._authService.closeAdminsiteWindow();
    }
  }
}
